'use client';

import { tss } from 'tss-react/mui';

import { Or2Container } from '../layout/Or2Container';

import type { Or2TabProps } from './Or2Tabs';
import { Or2Tabs } from './Or2Tabs';

const useStyles = tss.create(({ theme }) => ({
  tabOuterContainer: {
    backgroundColor: theme.palette.common.white,
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    borderLeft: `1px solid ${theme.cardBorder}`,
    borderRight: `1px solid ${theme.cardBorder}`,
    borderBottom: `1px solid ${theme.cardBorder}`,
  },
}));

export const Or2NavTabs = ({ tabs, ...other }: Or2TabProps) => {
  const { classes } = useStyles();

  return (
    <div className={classes.tabOuterContainer}>
      <Or2Container mainContent={false}>
        <Or2Tabs tabs={tabs} {...other} />
      </Or2Container>
    </div>
  );
};
